$(() => {
    const modalDiv = $('.contact-confirmation-modal').first();
    const isContactConfirmed = $('input#contact-confirmed').val() === 'True';

    if (isContactConfirmed) {
      modalDiv.modal('show');
    }

    document.body.addEventListener('htmx:afterSwap', function (evt) {
      if(evt.detail.xhr.response.includes("form-submitted")){
        if(modalDiv.length){
          modalDiv.modal('show');
        }
      }
    })
})
